module.exports = __webpack_public_path__ + "static/img/header.0eeaf01d.png";